import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const VerifyEmail = () => {
    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const queryString = window.location.search;
    const VerifyId = (new URLSearchParams(queryString)).get('verif');
    const Email = (new URLSearchParams(queryString)).get('email');

    useEffect(() => {
        if(VerifyId === null || VerifyId.length < 24 || Email === null) {
            Navigate("/")
        }
    },[VerifyId, Email, Navigate])

    const [Wrong, setWrong] = useState(false);
    const [Send, setSend] = useState(false);
    const [PWD,setPWD] = useState("");
    const [Loading, setLoading] = useState(false);
    const [Success, setSuccess] = useState(false);

    function tabChange(current,val){
        let tmp = document.getElementById(current)
        tmp.value = tmp.value.replace(/[^A-Za-z0-9]/g,'');
        tmp.value = tmp.value.replace(/[AEIOUaeiou]/g,'');
        tmp.value = tmp.value.toUpperCase()
        let ele = document.querySelectorAll('input[name="code"]');
        if(tmp.value !== '') {
            if(ele[val-1].value !== '' && val !== 8){
                ele[val].focus()
            }
        } else if(ele[val-1].value === '' && val !== 1){
            ele[val-2].focus()
        }
    }
    
    document.addEventListener("paste", function(e) {
        let formSelected = document.getElementById("PwdInput")
        if (formSelected.contains(e.target)) {
            var data = e.clipboardData.getData('Text');
            // split clipboard text into single characters
            data = data.split('');
            // find all other text inputs
            [].forEach.call(document.querySelectorAll("input[type=text]"), (node, index) => {
            // And set input value to the relative character
            if(data[index] !== undefined) {
              node.value = data[index];
            } else {
              node.value = "";
            }
            });
        }
    });

    const Verification = useCallback(async () => {
        setSend(false)
        setLoading(true)
        let params = {
            OID: VerifyId,
            pwd: PWD,
            email: Email
        };
        
        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(params)
        };
        
        try{
            
            const resp = await fetch("https://ymc-doc-api.azurewebsites.net/registeruser", requestOptions)
            if(resp.message === "Email Exists") {
                return MySwal.fire({
                          icon: "error",
                          title: "Ocurrió un error al crear la cuenta",
                          text: "El correo ingresado ya tiene una cuenta asociada",
                          showConfirmButton: true
                        });
            }
            if(resp.message === "Does not exist") {
                return MySwal.fire({
                          icon: "error",
                          title: "Ocurrió un error al crear la cuenta",
                          text: "El código de validación ha expirado, por favor registre su cuenta otra vez",
                          showConfirmButton: true
                        }).then((result) => {
                            if (result.isConfirmed) {
                              Navigate("/");
                            }
                        });
            }
            if (resp.status !== 200){
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error confirmando el correo",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
            }
            const data = await resp.json();

            let params2 = {
                email: data.graph.email,
                rut: data.graph.rut,
                phone: data.graph.phone,
                born: data.graph.born,
                sex: data.graph.gender,
                region: data.graph.region,
                commune: data.graph.commune,
            };
            
            let requestOptions2 = {
                method: 'POST',
                redirect: 'follow',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(params2)
            };

            let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/saveuserdata", requestOptions2)
            if (resp2.status !== 200){
                if(resp2.status !== 500) {
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error confirmando el correo 2",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
                } 
            }

            if(!data.res.acknowledged) {
                setWrong(true)
                setLoading(false)
                if(data.message === "Exists") {
                  return MySwal.fire({
                            icon: "error",
                            title: "Ocurrió un error al crear la cuenta",
                            text: "La cuenta ya fue verificada",
                            showConfirmButton: true
                          });
                }
                if(data.message === "Does not exist") {
                    return MySwal.fire({
                              icon: "error",
                              title: "Ocurrió un error al crear la cuenta",
                              text: "Su código de verificación ha expirado, por favor registre su cuenta otra vez",
                              showConfirmButton: true,
                              confirmButtonText: "Volver a Registrar Usuario",
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    Navigate("/")
                                }
                            });
                }
                if(data.message !== "Incorrect") {
                    return MySwal.fire({
                            icon: "error",
                            title: "Ocurrió un error al crear la cuenta",
                            text: "Por favor inténtelo más tarde",
                            showConfirmButton: true
                            });
                }
            } else {
                setLoading(false)
                MySwal.close()
                setSuccess(true)
            } 
        } catch(error){
            setWrong(true)
            setLoading(false)
            return false
        }
    },[Email, MySwal, Navigate, PWD, VerifyId])

    function verifyPwd() {
        let ele = document.querySelectorAll('input');
        let allinputs = ""
        for(let i=0;i<ele.length;i++) {
            allinputs += ele[i].value
        }
        if(allinputs.length !== 8) {
            setWrong(true)
        } else {
            setWrong(false)
            setPWD(allinputs)
            setSend(true)
        }
    }

    useEffect(() => {
        if(Send) {
            setSend(false)
            Verification()
        }
    },[Send, Verification]);
    
    return (
        <>
        {!Success ?
        <div className='VerifyEmailFull'>
            <div className='VerifyEmailInnerBox3'>
                <div className='VerifyEmailInnerBoxEmailVerification'>
                    <div className='VerifyEmailInnerBoxEmailVerificationUpTitle'>Valida tu cuenta yomecontrolo</div>
                    <img alt="" className='VerifyEmailInnerBoxEmailVerificationImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage5Vect.svg" />
                    <h2 className='VerifyEmailInnerBoxEmailVerificationTitle'>Ingresa el codigo de 8 digitos</h2>
                    <div className='VerifyEmailInnerBoxEmailVerificationInputs'>
                        <form action="" className="RemakeOrderPwdInputForm" id="PwdInput">
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput1" name="code" onKeyUp={() => tabChange("PwdInput1",1)} maxLength={1} />
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput2" name="code" onKeyUp={() => tabChange("PwdInput2",2)} maxLength={1} />
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput3" name="code" onKeyUp={() => tabChange("PwdInput3",3)} maxLength={1} />
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput4" name="code" onKeyUp={() => tabChange("PwdInput4",4)} maxLength={1} />
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput5" name="code" onKeyUp={() => tabChange("PwdInput5",5)} maxLength={1} />
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput6" name="code" onKeyUp={() => tabChange("PwdInput6",6)} maxLength={1} />
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput7" name="code" onKeyUp={() => tabChange("PwdInput7",7)} maxLength={1} />
                            <input className="RemakeOrderPwdInputOtp" type="text" id="PwdInput8" name="code" onKeyUp={() => tabChange("PwdInput8",8)} maxLength={1} />
                        </form>
                    </div>
                    {Wrong ?
                        <div className='RemakeOrderPwdInputVerifyWrongPwd'>Clave incorrecta</div>
                    : null }
                    {Loading ?
                        <div className="GeneralPurpleButtonFlex" style={{marginInline:"auto"}}>
                            <div className="GeneralPurpleButtonText">Cargando...</div>
                            <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                        </div>
                    :
                        <div className="GeneralPurpleButtonFlex" style={{marginInline:"auto"}} onClick={() => verifyPwd()}>
                            <div className="GeneralPurpleButtonText">Verificar</div>
                            <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                        </div>
                    }
                </div>
            </div>
        </div>
        :
        <div className='VerifyEmailFull'>
            <div className='VerifyEmailInnerBox3'>
                <div className='VerifyEmailInnerBoxEmailVerification'>
                    <div className='VerifyEmailInnerBoxEmailVerificationUpTitle'>¡Tu perfil fue creado!</div>
                    <img alt="" className='SignInInnerBox2BigImage' src="https://ymc.blob.core.windows.net/public/B2B/ProfileWelcomeImage7Vect.png" />
                    <div className='VerifyEmailSuccessTexts'>
                        <div className='UserProfileUpTitle'>¡Tu perfil fue creado!</div>
                        <h2 className='UserProfileTitle'>Autogestionar tu salud nunca fue tan fácil</h2>
                        <div className='VerifyEmailSuccessSubtitleText'>En tu portal podrás:
                            <br/> • Conocer tu riesgo de enfermedades cardiovasculares y metabólicas.
                            <br/> • Evaluar tus hábitos de vida y  de sueño.
                            <br/> • Emitir las órdenes médicas que necesites para ponerte a día con tu salud.
                        </div>
                        <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => Navigate("/")} style={{width:"100%"}}>
                            <div className="GeneralPurpleButtonText">Ir a mi portal</div>
                            <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        </>
    );
};

export default VerifyEmail;